import React from 'react'
import { ButtonGroup, Heading, Hr, Paragraph } from '@pandiafi/design-system'

export type ContractChangeTypeOption<T extends string> = {
  id: T
  label: string
  description: string
  disabled: boolean
}

type ContractChangeTypeChoiceProps<T extends string> = {
  heading: string
  options: ContractChangeTypeOption<T>[]
  value: T | undefined
  onChange: (value: T) => void
}

export const ContractChangeTypeChoice = <T extends string>({
  heading,
  options,
  value,
  onChange,
}: ContractChangeTypeChoiceProps<T>) => (
  <>
    <Heading element="h3" size="l" className="mb-4 font-medium">
      {heading}
    </Heading>

    <ButtonGroup
      className="w-full"
      suggestions={options.map(({ id, label, disabled }) => ({
        id,
        label,
        disabled,
      }))}
      value={value}
      onChange={(id) => {
        const option = options.find((o) => o.id === id)

        if (option) {
          onChange(option.id)
        }
      }}
      sameSize
      aria-label={heading}
      data-testid="contractChangeTypeChoice"
    />

    {value === undefined ? (
      <div className="mt-6 space-y-2">
        {options.map((option) => (
          <Paragraph key={option.id}>{option.description}</Paragraph>
        ))}
      </div>
    ) : (
      <Hr className="my-10 border-common-gray-4" />
    )}
  </>
)
